
import React from 'react';
import { Phone, Mail, Home } from 'lucide-react';

const ContactDetails: React.FC = () => {
  return (
    <div>
      <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Get in Touch</h2>
      <p className="text-lg text-gray-600 mb-8">
        Ready to eliminate IT headaches? Contact us today for a free consultation and 
        discover how we can help your business thrive with the right technology solutions.
      </p>
      
      <div className="space-y-6">
        <div className="flex items-start">
          <div className="bg-itmgmt-medium-blue bg-opacity-10 p-3 rounded-full mr-4">
            <Phone className="text-itmgmt-medium-blue" size={20} />
          </div>
          <div>
            <h3 className="font-semibold text-itmgmt-dark-blue">Phone</h3>
            <p className="text-gray-600">Call us for immediate assistance</p>
            <a href="tel:+18777486468" className="text-itmgmt-medium-blue font-medium hover:underline">
              +1-877-748-6468
            </a>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="bg-itmgmt-medium-blue bg-opacity-10 p-3 rounded-full mr-4">
            <Mail className="text-itmgmt-medium-blue" size={20} />
          </div>
          <div>
            <h3 className="font-semibold text-itmgmt-dark-blue">Email</h3>
            <p className="text-gray-600">Send us an email anytime</p>
            <a href="mailto:info@itmgmtsol.com" className="text-itmgmt-medium-blue font-medium hover:underline">
              info@itmgmtsol.com
            </a>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="bg-itmgmt-medium-blue bg-opacity-10 p-3 rounded-full mr-4">
            <Home className="text-itmgmt-medium-blue" size={20} />
          </div>
          <div>
            <h3 className="font-semibold text-itmgmt-dark-blue">Location</h3>
            <p className="text-gray-600">Servicing clients across the U.S.</p>
            <p className="text-itmgmt-dark-gray">Primarily focused in Airmont, NY and surrounding areas</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
